import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { logo } from '../assets';

const DrawerMenu = ({ isOpen, toggleNavigation }) => {
  const [activeItem, setActiveItem] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const [isHovering, setIsHovering] = useState(false);

  const navigation = [
    { name: 'Home', subMenu: [], link: '/' },
    { name: 'Company', subMenu: ['About Futeur', 'Careers', 'Legal', 'Vision', 'Contact'] },
    { name: 'Credit', subMenu: ['Monitoring'] },
    { name: 'Signup', subMenu: [], link: 'https://app.futeur.ai/signup', external: true },
    { name: 'Login', subMenu: [], link: 'https://app.futeur.ai/signin', external: true },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleMouseEnter = (itemName) => {
    setActiveItem(itemName);
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    setTimeout(() => {
      if (!isHovering) {
        setActiveItem(null);
      }
    }, 300); // Small delay to allow moving to submenu
  };

  const toggleSubMenu = (itemName) => {
    setExpandedItem(expandedItem === itemName ? null : itemName);
  };

  const renderMenuItem = (item) => {
    if (item.link) {
      if (item.external) {
        return (
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-2xl ${isMobile ? '' : 'lg:text-4xl'} font-bold uppercase transition-colors duration-300 block ${
              activeItem === item.name ? 'text-white' : 'text-gray-500'
            }`}
            onClick={toggleNavigation}
          >
            {item.name}
          </a>
        );
      } else {
        return (
          <Link
            to={item.link}
            className={`text-2xl ${isMobile ? '' : 'lg:text-4xl'} font-bold uppercase transition-colors duration-300 block ${
              activeItem === item.name ? 'text-white' : 'text-gray-500'
            }`}
            onClick={toggleNavigation}
          >
            {item.name}
          </Link>
        );
      }
    } else {
      return (
        <span
          className={`text-2xl ${isMobile ? '' : 'lg:text-4xl'} font-bold uppercase transition-colors duration-300 block ${
            activeItem === item.name ? 'text-white' : 'text-gray-500'
          }`}
          onClick={() => isMobile && toggleSubMenu(item.name)}
        >
          {item.name}
        </span>
      );
    }
  };

  const renderSubMenu = (item) => {
    if (!item.subMenu.length) return null;

    return (
      <ul
        className={`space-y-3 mt-3 overflow-hidden transition-all duration-300 ease-in-out ${
          isMobile ? '' : 'pl-8 lg:pl-12'
        }`}
        style={{ maxHeight: isMobile && expandedItem === item.name ? '100vh' : isMobile ? '0' : 'auto' }}
      >
        {item.subMenu.map((sub, idx) => (
          <li key={idx}>
            <Link
              to={`/${sub.toLowerCase().replace(/\s+/g, '-')}`}
              className={`${isMobile ? 'text-base' : 'text-xl lg:text-3xl'} hover:text-gray-300 transition-colors`}
              onClick={toggleNavigation}
            >
              {sub}
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      className={`fixed inset-0 z-40 bg-black transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <div className="relative flex flex-col h-full w-full lg:flex-row">
        <div
          className={`flex flex-col w-full ${
            isMobile ? 'p-6' : 'lg:w-1/3 p-6 lg:p-20'
          } bg-black text-white justify-center lg:justify-center`}
          style={{ minHeight: isMobile ? 'auto' : '100vh' }}
        >
          <div className={`flex flex-col items-center ${isMobile ? 'mt-40' : 'mt-0'}`}>
            <div className="absolute top-4 left-5 lg:top-20 lg:left-40">
              <img src={logo} alt="Futeur Logo" className={`${isMobile ? 'h-10 w-auto' : 'h-10 w-auto lg:h-20'}`} />
            </div>

            <nav className={`${isMobile ? 'space-y-4 text-center' : 'space-y-5 lg:space-y-10'}`}>
              {navigation.map((item, index) => (
                <div
                  key={index}
                  className="relative group cursor-pointer"
                  onMouseEnter={() => !isMobile && handleMouseEnter(item.name)}
                  onMouseLeave={() => !isMobile && handleMouseLeave()}
                  onClick={() => isMobile && setActiveItem(null)} 
                >
                  {renderMenuItem(item)}
                  {isMobile && renderSubMenu(item)}
                </div>
              ))}
            </nav>
          </div>
        </div>

        {!isMobile && (
          <div className="flex flex-col w-full lg:w-2/3 p-6 lg:p-10 bg-black text-white justify-center">
            <div className="relative">
              {navigation.map((item, index) => (
                <div
                  key={index}
                  className={`transition-opacity duration-200 ease-in-out ${
                    activeItem === item.name ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  {activeItem === item.name && renderSubMenu(item)}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DrawerMenu;
